import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

const MaterialCheckIcon = () => {
  return <CheckOutlinedIcon htmlColor="#003F2D" />;
};

export default MaterialCheckIcon;
